import React, { useEffect, useState } from 'react';
import {
  Edit, SimpleForm, TextInput, NumberInput, SelectInput, required, useTranslate,
} from 'react-admin';
import { Grid, useTheme } from '@mui/material';
import { httpClient } from '@/utils/httpClient';
import { FormPageTitle, FormSection, FormToolbar } from '@/components/shell';

const BACK_TO = '/kyc-config?tab=default-mapping';

interface DefaultMappingForm {
  id: string;
  standardFieldName: string;
  kycFieldId?: string;
  kycFields?: { id: string };
  priority?: number;
}

export const DefaultMappingEdit = () => {
  const t = useTranslate();
  const theme = useTheme();
  const [kycFields, setKycFields] = useState<Array<{ id: string; name: string }>>([]);
  useEffect(() => {
    httpClient.get<Array<{ id: string; name: string }>>('/admin/kyc-field/GetAllKYCFields').then((r) => setKycFields(r.data));
  }, []);

  const transform = (data: DefaultMappingForm) => ({
    id: data.id,
    standardFieldName: data.standardFieldName,
    kycFieldId: data.kycFieldId || data.kycFields?.id,
    priority: data.priority ?? 0,
  });

  return (
    <Edit mutationMode="pessimistic" transform={transform} redirect={BACK_TO} actions={<FormPageTitle mode="edit" />}>
      <SimpleForm toolbar={<FormToolbar backTo={BACK_TO} showDelete />}>
        <FormSection title={t('resources.default-mapping.name', { smart_count: 1 })}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <TextInput
                source="standardFieldName"
                label={t('resources.default-mapping.fields.standardFieldName')}
                validate={required()}
                fullWidth
                InputProps={{ sx: { fontFamily: theme.custom.text.mono } }}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <SelectInput
                source="kycFields.id"
                label={t('resources.default-mapping.fields.kycFields.name')}
                choices={kycFields}
                validate={required()}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <NumberInput
                source="priority"
                label={t('resources.default-mapping.fields.priority')}
                min={0}
                fullWidth
                helperText={t('screens.defaultMappings.priorityHelp')}
              />
            </Grid>
          </Grid>
        </FormSection>
      </SimpleForm>
    </Edit>
  );
};
